import { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';
import { BlockSpinner } from '../components/loading';
import routes from './routes';

export { AppRoutes, AppRoutes as default };

function AppRoutes() {
  const routing = useRoutes(routes);

  return <Suspense fallback={<BlockSpinner />}>{routing}</Suspense>;
}
